module.exports = __webpack_public_path__ + "static/img/PARKSON.9783fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/PARKSON.png
// module id = jVcB
// module chunks = 34